import { defineStore } from "pinia";
import keycloakService from "../services/keycloak-service";
import { UserprofileApi } from "../cr-userprofile-api-client/src";

export const useAuthStore = defineStore({
  id: "storeAuth",
  state: () => {
    return {
      authenticated: false,
      token: undefined,
      refToken: undefined,
      username: undefined,
      userId: undefined,
      email: undefined,
      bahncardPercent: 0,
      deutschlandticketUsed: false,
      maxOepvChanges: 4,
      maxOepvChanges25Km: 4,
      maxOepvChanges50Km: 4,
      maxOepvChanges100Km: 4

    }
  },
  persist: true,
  getters: {
    getKeycloakObj(state) {
      if (!state.keycloakObj) {
        state.keycloakObj = keycloakService.keycloakObj;
      }
      return state.keycloakObj;
    },
    getAuthenticated(state) {
      return state.authenticated;
    },
  },
  actions: {
    // Initialize Keycloak OAuth
    storeLogin(keycloak, userData, clearData = true) {
      console.log("storing login, userdata=", userData)
      if (clearData) {
        this.clearUserData();
      }
      this.authenticated = keycloak.authenticated;
      this.username = userData.username;
      this.email = userData.email;
      this.userId = userData.id;
      this.token = keycloak.token;
      this.refToken = keycloak.refreshToken;
      console.log("storeLogin-userData=", userData)
    },
    modifyUserData(userData) {
      const body = {body: {...userData}}
      console.log("modifyUserData-userData=",body)
      new UserprofileApi().modifyUser(body, (error, data, response) => {
        console.log("modifyUserData -data=", data)
      
      });
    },
    fetchUserData(userId) {
      console.log("fetchUserData called")
      new UserprofileApi().getUser(userId, (error, data, response) => {
        console.log("fetchUserData -data=", data)
        if (!(data instanceof Object)) {
          return;
        }
        this.bahncardPercent = data.bahncardPercent;
        this.deutschlandticketUsed = data.deutschlandticketUsed;
        this.maxOepvChanges = data.maxOepvChanges;
        this.maxOepvChanges25Km = data.maxOepvChanges25Km;
        this.maxOepvChanges50Km = data.maxOepvChanges50Km;
        this.maxOepvChanges100Km = data.maxOepvChanges100Km;
      });

    },

    // Logout user
    async storeLogout() {
      try {
        await keycloakService.CallLogout(import.meta.env.VITE_APP_URL);
        await this.clearUserData();
      } catch (error) {
        console.error(error);
      }
    },
    // Refresh user's token
    async refreshUserToken() {
      try {
        const keycloak = await keycloakService.CallTokenRefresh();
        this.initOauth(keycloak, false);
      } catch (error) {
        console.error(error);
      }
    },
    // Clear user's store data
    clearUserData() {
      this.authenticated = false;
      this.user = {};
    }


  }
});